import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import { ActivitySegmentHeader } from "./ActivitySegmentHeader";
import { Activity } from "./Activity";
import { segmentList } from "../../../utils/listHelpers";
const toISODateFragment = (date) => date.toISOString().substring(0, 10);
const toFormattedDate = (isoDate) => new Date(isoDate).toLocaleDateString();
const segmentActivities = (activities = []) => {
    return segmentList(activities, item => {
        const itemDate = toISODateFragment(new Date(item.createdDate));
        const today = toISODateFragment(new Date());
        const yesterday = toISODateFragment(new Date(Date.now() - 24 * 60 * 60 * 1000));
        switch (itemDate) {
            case today:
                return "Today";
            case yesterday:
                return `Yesterday (${toFormattedDate(itemDate)})`;
            default:
                const dayOfWeek = [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday",
                ][new Date(itemDate).getDay()];
                return `${dayOfWeek} ${toFormattedDate(itemDate)}`;
        }
    });
};
export const ActivitiesSegments = ({ activities, disabled, onIsReady, }) => {
    const { segments } = segmentActivities(activities);
    return (React.createElement(Fragment, null,
        React.createElement(Grid, { container: true, spacing: 3, alignItems: "baseline" }, segments.map(segment => {
            return (React.createElement(React.Fragment, { key: segment.label },
                React.createElement(ActivitySegmentHeader, { label: segment.label }),
                segment.data.map(item => (React.createElement(Activity, { model: item, key: item.id, disabled: disabled, onIsReady: onIsReady })))));
        }))));
};
